import React, { useRef, useState, useMemo } from "react";
import { motion, useInView, AnimatePresence } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./VideoGallery.css";

const videosData = [
  {
    youtubeId: "_vD25Gfue7I",
    category: "Event",
    description: "Happy to be associated with MSB Association - Dima Kats, founder of Clear Junction",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "8PaMAfnQ8Jo",
    category: "Discussion Panel",
    description: "Can MSBs truly scale across fiat & digital rails without compromising trust?",
    event: "Annual Meet 2026"
  },

  {
    youtubeId: "PwiUREaSt6g",
    category: "Keynote Speaker",
    description: "Stablecoins in Remittance – Are they the future of cross-border payments? | MSB Association Annual Members Meet 2026",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "TSv9xk0M6Ag",
    category: "Event",
    description: "MSB Association Annual Meet 2026 - Best Moments",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "dL3luJheLcE",
    category: "Testimonials",
    description: "Insightful discussions on stablecoins - Mr. Giordano Cortese, First Rate Exchange Services Ltd",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "p5ASujOCF8M",
    category: "Testimonials",
    description: "There were some really interesting discussions around stablecoins – Mr. William Brewer, Link FX",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "0s2HhkJy-IY",
    category: "Testimonials",
    description: "The opportunity to engage with fellow stakeholders is invaluable – Mr. Thomas Onih, Director, Netsible Solutions Ltd",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "fH3r1PNLy6I",
    category: "Testimonials",
    description: "A highly valuable platform for networking and business growth – Mr. Kamal Paudel, Director, IME London",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "wPBiaOmqt3U",
    category: "Testimonials",
    description: "Great to be around fellow MSBs and ecosystem partners – Mr. Oliver Calma, Founder & CEO, BC Remit",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "WSwtoIrUZvg",
    category: "Testimonials",
    description: "We got so many exchanges and I’ve learnt so many things I didn’t know before | Mr. Abdul Aden, TassaPay",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "klF4HyX6n3s",
    category: "Testimonials",
    description: "An eye opener and a great learning experience for us all | Mrs. Bosede Adeniyi, Blessed Exchange Ltd.",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "ynKoXbkmuxE",
    category: "Testimonials",
    description: "A really great event, and I hope to attend again next year | Ms. Teresa Cameron, CEO of Clear Junction",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "bcJO5Ffwx8k",
    category: "Testimonials",
    description: "Happy to support and contribute to the MSB sector wherever possible | Mr. James Borley, Complyport",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "VMvlNZVa3FQ",
    category: "Testimonials",
    description: "Very nice event, very nice people - Mr. Dima Kats founder of Clear Junction.",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "WCF_Uyq2KOs",
    category: "Webinars",
    description: "HMRC Visit Preparation - Stay Compliant & Inspection Ready  by Mr. Ajinkya Patil",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "ZURf0z5Xq1o",
    category: "Event",
    description: "Save the Date - MSB Association Annual Members Meet 2026",
    event: "Annual Meet 2026"
  },
  {
    youtubeId: "eF8qPqz7yOY",
    category: "Keynote Speaker",
    description: "How do you scale an MSB while meeting FCA expectations?",
    event: "Summer Meet 2026"
  },
  {
    youtubeId: "Wg5Eyu968Tw",
    category: "Keynote Speaker",
    description: "What is the reality of today's MSB industry—and where is it heading next?",
    event: "Summer Meet 2026"
  },
  {
    youtubeId: "whimeMEMnA0",
    category: "Keynote Speaker",
    description: "What does it take to build a successful remittance business in today's evolving financial landscape?",
    event: "Summer Meet 2026"
  },
  {
    youtubeId: "Bbt1zNzo-i8",
    category: "Testimonials",
    description: "The insights shared at the event inspired us to grow — Mr. Dawood, Fone Town Ltd",
    event: "Summer Meet 2026"
  },
  {
    youtubeId: "GefxxOfgLYk",
    category: "Testimonials",
    description: "Here's why Peratera praised the MSB Association Summer Members Meet 2026!",
    event: "Summer Meet 2026"
  },
  {
    youtubeId: "1x6gt-_1vDk",
    category: "Testimonials",
    description: "It's been an amazing event, with so many special people here Mr. Ben Evans, Sales Director Peratera.",
    event: "Summer Meet 2026"
  },
  {
    youtubeId: "VQObfK68vqc",
    category: "Testimonials",
    description: "I'm very glad to be a member of the MSB Association Mr. Sai, CEO of Rupy Global Solutions Limited.",
    event: "Summer Meet 2026"
  },
  {
    youtubeId: "HIg25bSunf4",
    category: "Testimonials",
    description: "This event is a good opportunity for my company and my business Mr. lotfi, Mobile Exchange Limited.",
    event: "Summer Meet 2026"
  },
  {
    youtubeId: "LoqyMMySFaw",
    category: "Testimonials",
    description: "It has been a very good experience for me and my company Ms.Maysoon, Alwakeel International Ltd",
    event: "Summer Meet 2026"
  },
  {
    youtubeId: "k6wlJt-NQas",
    category: "Testimonials",
    description: "It has allowed everybody from the MSB community to gather here - Mr. Mizan Abdulrouf, 5 Pillars Law",
    event: "Summer Meet 2026",
  },
  {
    youtubeId: "q9U48IV7cmg",
    category: "Testimonials",
    description: "I'll definitely recommend everyone in the industry to be here -Mr. Kemal SAHIN, Cardaq",
    event: "Summer Meet 2026",
  },
  {
    youtubeId: "ITlrJNozBk4",
    category: "Testimonials",
    description: "Overall 10/10. Fantastic, and we'll definitely recommend it for next year Mr. jordan Plimley, Thunes",
    event: "Summer Meet 2026",
  },
  {
    youtubeId: "JkPx6uxC_mU",
    category: "Testimonials",
    description: "It's another opportunity to bring great minds together, Ms. Temitope, Goldluxel Services Ltd",
    event: "Summer Meet 2026",
  },
  {
    youtubeId: "BouKHH7fWxs",
    category: "Testimonials",
    description: "I've had the opportunity to meet many people from across the industry Mr. Jay, Mercury Danati Ltd",
    event: "Summer Meet 2026",
  },
  {
    youtubeId: "yl32Hp7DXHo",
    category: "Testimonials",
    description: "A fantastic venue, great mix of people, and great Opportunities. - Mr. William Brewer from Link FX",
    event: "Summer Meet 2026",
  },
  {
    youtubeId: "ul0W5Q09xLY",
    category: "Testimonials",
    description: "\"Today's event was really good. I enjoyed it.\" - Mr.Caleb Epelle-Oboko from Prune Payments Ltd",
    event: "Summer Meet 2026"
  },
];

// Set to true to display the Summer Meet 2026 tab and its videos
const ENABLE_SUMMER_MEET = true;

const categories = ["All", "Event", "Webinars", "Discussion Panel", "Keynote Speaker", "Testimonials"];

const VideoThumbnail = ({ youtubeId, onClick, index }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  const thumbnailVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      ref={ref}
      className="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex justify-content-center"
      variants={thumbnailVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      onClick={onClick}
    >
      <div className="video-thumbnail-container">
        <img
          src={`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`}
          alt="Video thumbnail"
          className="img-fluid gallery-thumb"
        />
        <div className="play-icon">
          <i className="fa-solid fa-play"></i>
        </div>
      </div>
    </motion.div>
  );
};

const Videogallery2026 = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeCategory, setActiveCategory] = useState("All");
  const [activeEvent, setActiveEvent] = useState(ENABLE_SUMMER_MEET ? "Summer Meet 2026" : "Annual Meet 2026");

  const availableEvents = ENABLE_SUMMER_MEET
    ? ["Summer Meet 2026", "Annual Meet 2026"]
    : ["Annual Meet 2026"];

  const eventFilteredVideos = useMemo(() => {
    return videosData.filter((v) => v.event === activeEvent);
  }, [activeEvent]);

  const filteredVideos = useMemo(() => {
    return activeCategory === "All"
      ? eventFilteredVideos
      : eventFilteredVideos.filter((v) => v.category === activeCategory);
  }, [activeCategory, eventFilteredVideos]);

  const openModal = (index) => {
    setCurrentIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const showNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % filteredVideos.length);
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + filteredVideos.length) % filteredVideos.length);
  };

  const title = "Video Gallery 2026";
  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: { delay: index * 0.05, duration: 0.4, ease: "easeInOut" },
    }),
  };

  const gridVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0, transition: { duration: 0.3 } },
  };

  return (
    <>
      <Helmet>
        <title>Video Gallery 2026 | Money Service Business Advocacy UK</title>
        <meta name="description" content="View videos from the 2026 MSB Advocacy UK event, including expert talks, networking highlights, and more." />
      </Helmet>

      <main className="page_content">
        <section className="page_header text-center section_decoration" style={{ background: "#333", position: "relative", padding: "" }}>
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{ display: "inline-block", whiteSpace: "pre-wrap" }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">Video Gallery 2026</a>
              </li>
            </ul>
          </div>
        </section>

        <style jsx>{`
          .page_header {
            padding: 120px 0 60px;
          }
          @media (max-width: 768px) {
            .page_header {
              padding: 100px 0 40px;
            }
            .page_title {
              font-size: 32px !important;
              line-height: 1.2 !important;
            }
          }
          @media (max-width: 480px) {
            .page_title {
              font-size: 26px !important;
            }
          }
        `}</style>

        <section className="service_section section_space" style={{ overflow: "hidden" }}>

          {availableEvents.length > 1 && (
            <div className="container event-underline-tabs-container">
              <div className="event-underline-tabs">
                {availableEvents.map((evt) => (
                  <button
                    key={evt}
                    className={`event-underline-btn ${activeEvent === evt ? "active" : ""}`}
                    onClick={() => {
                      setActiveEvent(evt);
                      setActiveCategory("All"); // Reset category when changing events
                    }}
                  >
                    {evt}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="container">
            {/* Category Tabs */}
            <div className="gallery_tabs_container mb-5 text-center">
              <div className="merged_tabs_pill">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    className={`gallery_tab_btn ${activeCategory === cat ? "active" : ""}`}
                    onClick={() => setActiveCategory(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                key={activeCategory}
                variants={gridVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                className="row align-items-center mt-5 justify-content-center"
              >
                {filteredVideos.map((video, index) => (
                  <VideoThumbnail
                    key={video.youtubeId}
                    youtubeId={video.youtubeId}
                    index={index}
                    onClick={() => openModal(index)}
                  />
                ))}

                {filteredVideos.length === 0 && (
                  <div className="col-12 text-center py-5">
                    <p className="no_videos_text">No videos available in this category yet.</p>
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>
        </section>

        {modalOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="video-responsive">
                <iframe
                  width="853"
                  height="450"
                  src={`https://www.youtube.com/embed/${filteredVideos[currentIndex]?.youtubeId}?autoplay=1&rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Embedded youtube"
                />
              </div>

              {filteredVideos[currentIndex]?.description && (
                <p className="modal-description">
                  {filteredVideos[currentIndex]?.description}
                </p>
              )}

              <button className="modal-close" onClick={closeModal}>×</button>
              <button className="modal-prev" onClick={showPrev}>❮</button>
              <button className="modal-next" onClick={showNext}>❯</button>
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default Videogallery2026;
